var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"regulation-update"},[_c('BaseIcon',{attrs:{"icon":"ic_info","width":"48px","height":"48px","colors":_vm.iconColor}}),_c('BaseText',{attrs:{"size":"sm"}},[_vm._v(_vm._s(_vm.disclaimer))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }